import type { ProductDetailState } from 'reducers/detail/productDetail';
import type { SizeChartModalContent } from 'components/common/SizeChartModal';
import useMartyContext from 'hooks/useMartyContext';
import { MelodyAccordion } from 'components/common/MelodyAccordion';
import { ProductAccordionList } from 'components/productdetail/accordions/ProductAccordionList';

export interface ProductAccordionsProps {
  colorId: string;
  openSizeChartModal: (content: SizeChartModalContent) => void;
  product: ProductDetailState;
  productId: string;
}

export const ProductAccordions = (props: ProductAccordionsProps) => {
  const { testId } = useMartyContext();

  return (
    <div data-test-id={testId('accordionContainer')}>
      <MelodyAccordion defaultOpenAll openMultiple>
        <ProductAccordionList {...props} />
      </MelodyAccordion>
    </div>
  );
};
